import { DiffHunkComponent } from "@/components/Diff/DiffHunk.tsx"
import { DiffLineComponent } from "@/components/Diff/DiffLine.tsx"

import type { DiffTheme } from "@/components/Diff/diffColors.ts"
import type { DiffPart } from "@/components/Diff/diffTypes.ts"
import type { Property } from "csstype"
import type { IObservableValue } from "mobx"


export const DiffPartComponent = (props: {
  value: DiffPart
  theme: DiffTheme
  gutterWidth: IObservableValue<Property.Width>
}) => {
  if (props.value.type === "line") {
    return (
      <DiffLineComponent
        data={props.value.data}
        theme={props.theme}
        gutterWidth={props.gutterWidth}
      />
    )
  }

  if (props.value.type === "hunk") {
    return (
      <DiffHunkComponent
        range={props.value.data}
        theme={props.theme}
        gutterWidth={props.gutterWidth}
        expand={props.value.expand}
      />
    )
  }

  return null
}

